// extracted by mini-css-extract-plugin
module.exports = {"icon-container":"StarIcon_icon-container__zR4g4"};